import { createSelector } from 'reselect';
import { getItemsSubtotal, getOrderTotal } from '~shared/features/pricing/selectors/getOrderTotal';

export const getIsPriceUnconfirmed = createSelector([getOrderTotal], (total) => {
  if (!total) {
    return true;
  }

  return total.info_key === 'price_unavailable' || total.info_key === 'estimated';
});

// // items subtotal returns total minus all fees
export const getHasNoCopay = createSelector([getItemsSubtotal, getIsPriceUnconfirmed], (itemsSubtotal, unconfirmed) => {
  return !unconfirmed && !itemsSubtotal;
});

export const getIsPaymentMethodRequired = createSelector([getOrderTotal], (total): boolean => {
  if (!total) {
    return true;
  }

  return (total.value ?? 0) > 0 || total.info_key === 'price_unavailable';
});
